<template>
  <SchoolsForm :typeEndPoint="'adminSchoolsForm'" :dataParams="{}"/>
</template>
<script>
import SchoolsForm from '@/components/modules/admin/schools/form'
export default {
  name: 'SchoolFormCreate',
  components: {
    SchoolsForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/schools/create.vue